import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';
import { BaseLinkConf } from './base-link-conf';

export class ModuleLinkConf extends BaseLinkConf {
  menuLinksKeys: Array<NavKeys>;

  constructor(init?: Partial<ModuleLinkConf>) {
    super(init);
    Object.assign(this, init);
  }
}
